/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

// Billing page components
import PageLayout from "examples/LayoutContainers/PageLayout";
import AddQuestion from "./components/AddQuestion"
import EditQuestion from "./components/EditQuestion"
import DeleteQuestion from "./components/DeleteQuestion"
import { useEffect, useState } from "react";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";

import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Margin } from "@mui/icons-material";
function Billing() {
  const [loader, setLoader] = useState(true);
  const [Questions, setQuestions] = useState([]);
  const AppService = useAppServices();
  const [agency, Update] = useAgencyInfo();

   
  const getQuestions = async () => {
    const { response } = await AppService.chat.getquestions({
      query: `agency_id=${agency._id}`,
    });
    if (response) {
      setQuestions(response.data)
      setLoader(false);
    } else {
      setLoader(false);
    }
  };
  const onLoad = () => {
    getQuestions();
  };
  useEffect(() => {
    onLoad();
  }, []);
  const deletefunction=async(e)=>{
    const payload = {  
      _id: Oprationdata._id,
    };
    const { response } = await AppService.chat.deleteQuestion({
      payload,
      toaster: true,
    });
    if (response) {
       
      setdeleteModel(false)
            getQuestions()
    }
  }
  const Addfunction=async(e)=>{
    const payload = {
      user_message: e.target.user_message.value,
      prompt: e.target.prompt.value,
      agency_id: agency._id,
    };
    const { response } = await AppService.chat.addquestion({
      payload,
      toaster: true,
    });
    if (response) {
       
      setOpenAddMode(false)
      getQuestions();
    }
  }
  const editfunction = async(e,usermessage,prompt)=>{
    const payload = {
      user_message:usermessage,
      prompt: prompt,
      _id: Oprationdata._id,
    };
     
    const { response } = await AppService.chat.editquestion({
      payload,
      toaster: true,
    });
    if (response) {
       
      setEditModel(false)
      getQuestions();
    }
  }
  const [openAddMode,setOpenAddMode]=useState(false);
  const [editModel,setEditModel]=useState(false);
  const [deleteModel,setdeleteModel]=useState(false);
  const [Oprationdata,setOprationdata]=useState({});
  return (
    <PageLayout stickyNavbar>
    <SoftBox mt={4}>
      <SoftBox mb={3}>
        
        <Grid container spacing={4}>

          <Grid item xs={12} md={12}>
          
          <div style={{textAlign:"right"}}>

          <SoftButton style={{margin:"10px",}} onClick={()=>setOpenAddMode(true)} variant="outlined"  color="dark">Add Promt</SoftButton>
                       
         
          {openAddMode && <>
            <AddQuestion open={openAddMode} Addfunction={Addfunction} onClose={()=>setOpenAddMode(false)} />
          </>}
          {editModel && <>
            <EditQuestion open={editModel} editfunction={editfunction} Oprationdata={Oprationdata} onClose={()=>setEditModel(false)} />
          </>}
          {deleteModel && <>
            <DeleteQuestion open={deleteModel} deletefunction={deletefunction} Oprationdata={Oprationdata}  onClose={()=>setdeleteModel(false)} />
          </>}
           
          </div>
            <TableContainer  >
              <Table aria-label="simple table">
                 
                  <TableRow>
                    <TableCell>No#</TableCell>
                    <TableCell>Prompt title</TableCell>
                    <TableCell>Promt description</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
              
                <TableBody>
                  {/* Add TableRows and TableCells for your data */}
                  {Questions && Questions.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>{++index}</TableCell>
                        <TableCell>{item.user_message}</TableCell>
                        <TableCell>{item.prompt}</TableCell>
                        <TableCell style={{display:"flex"}}>
                        <SoftButton style={{marginRight:"10px"}}  onClick={()=>{setEditModel(true);setOprationdata(item)}} variant="outlined"  color="dark">Edit</SoftButton>
                        <SoftButton  onClick={()=>{setdeleteModel(true);setOprationdata(item)}}  variant="outlined"color="error"
                         >Delete</SoftButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  {/* Add more rows as needed */}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </SoftBox>
    </SoftBox>
  </PageLayout>
  );
}

export default Billing;
